import React from "react";
import useInbox from "./InboxTab/InboxContext";
let Tabs = [
  { id: "inbox", name: "Inbox" },
  { id: "artwork", name: "Artwork" },
  { id: "contacts", name: "Contacts" },
];

export default function RenderEmailTabs({ activeTab, setActiveTab }) {
  /* ******************** All States ************************* */
  const { setEmailsList } = useInbox();

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <>
      <div className="btn-group rounded-3 shadow-lg w-100" role="group">
        {Tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`btn btn-sm ${
              activeTab === tab.id ? "btn-primary" : "btn-outline-primary bg-"
            }`}
            onClick={(e) => {
              setActiveTab(tab.id);
              if (activeTab !== tab.id) {
                // resetAll();
                setEmailsList([]);
              }
            }}
          >
            {tab.name}
          </button>
        ))}
      </div>
    </>
  );
}
